import { SelectedAttribute } from '@/saleor/api';

interface FontStampProps {
  productStampAttributeValue?: string;
  styles?: any;
}

const FontStamp = ({ productStampAttributeValue, styles }: FontStampProps) => {
  return productStampAttributeValue ? (
    <div className={styles?.TypefaceCard__Stamp}>
      <span className={styles?.TypefaceCard__StampInner}>{productStampAttributeValue}</span>
    </div>
  ) : null;
};

export default FontStamp;

export const productStampAttribute = (attributes: Array<SelectedAttribute>) => {
  const stampAttribute = attributes.find((attribute) => attribute?.attribute?.slug === 'stamp');

  return stampAttribute?.values.length > 0 ? stampAttribute.values[0]?.name : '';
};

export const productStampColourScheme = (attributes: Array<SelectedAttribute>) => {
  const colourAttribute = attributes.find(
    (attribute) => attribute?.attribute?.slug === 'stamp-colours'
  );

  if (colourAttribute?.values.length > 0) {
    let coloursArray = colourAttribute.values[0]?.name.split(',');

    // Prevent non-hex code data
    const hexRegex = /^#[0-9A-F]{6}$/i;
    coloursArray = coloursArray.filter((colour) => hexRegex.test(colour));

    const arrayLength = coloursArray.length;
    if (arrayLength !== 2) return [];

    return coloursArray;
  }

  return [];
};
